import { Select } from "@scuf/common";
import "../../../features/components/dashboard/LeftContainer/css/leftContainer.scss";
const SelectDropdown = (props: any) => {
  return (
    <Select
      id={props.id}
      className={props.className}
      options={props.options}
      defaultValue={props.defaultValue}
      onChange={props.onChange}
      data-testid={props.dataTestid}
      value={props.value}
      disabled={props.disabled}
      search={true}
    />
  );
};
export default SelectDropdown;
